export default __webpack_public_path__ + "static/media/DreamJobs1_13.f39dd339.png";